import { useEffect, useState } from 'react';
import ConfirmationModal from '../../../components/commoncomponents/ConfirmationModal';
import Sidebar from './Sidebar';
import Header from './Header';
import ProfileModal from './ProfileModal';

function DashboardLayout({
  user,
  token,
  onLogout,
  onProfileUpdate,
  onPasswordChanged,
  activeView,
  onSelectView,
  children,
}) {
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const animationFrame = window.requestAnimationFrame(() => {
      setIsVisible(true);
    });

    return () => {
      window.cancelAnimationFrame(animationFrame);
    };
  }, []);

  function openLogoutModal() {
    setIsLogoutModalOpen(true);
  }

  function closeLogoutModal() {
    setIsLogoutModalOpen(false);
  }

  function openProfileModal() {
    setIsProfileModalOpen(true);
  }

  function closeProfileModal() {
    setIsProfileModalOpen(false);
  }

  function confirmLogout() {
    closeLogoutModal();
    onLogout();
  }

  return (
    <div
      className={`min-h-screen grid-cols-[260px_1fr] bg-[#fcfbf9] text-[#111111] transition-all duration-500 ease-out lg:grid ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-3 opacity-0'
      }`}
    >
      <Sidebar activeView={activeView} onSelectView={onSelectView} />

      <main className="p-4 sm:p-6 lg:p-[24px_30px_30px]">
        <Header
          user={user}
          onLogout={openLogoutModal}
          onOpenProfile={openProfileModal}
        />
        <section className="mt-6">{children}</section>
      </main>

      <ConfirmationModal
        isOpen={isLogoutModalOpen}
        title="Confirm Logout"
        description="Are you sure you want to log out of the current session?"
        confirmLabel="Logout"
        onConfirm={confirmLogout}
        onCancel={closeLogoutModal}
      />

      <ProfileModal
        isOpen={isProfileModalOpen}
        user={user}
        token={token}
        onClose={closeProfileModal}
        onSaveProfile={onProfileUpdate}
        onPasswordChanged={onPasswordChanged}
      />
    </div>
  );
}

export default DashboardLayout;
